import { createSelector } from '@reduxjs/toolkit'

interface AuthResetPasswordState {
	auth?: {
		error?: {
			resetPassword?: unknown
		}
		resetPassword?: unknown
	}
}

const selectErrors = (state: Record<string, unknown>) => (state as AuthResetPasswordState).auth?.error?.resetPassword
const selectResetPassword = (state: Record<string, unknown>) => (state as AuthResetPasswordState).auth?.resetPassword

export default createSelector(selectErrors, selectResetPassword, (errors, resetPassword) => ({ errors, resetPassword }))
